<template>
    <div class="w-full max-w-lg mx-auto bg-gray-100 p-6 rounded-lg shadow-md">
      <h2 class="text-2xl font-bold mb-6 text-center">Создать новую роль</h2>
      <form @submit.prevent="createRole" class="space-y-4">
        <div>
          <label class="block text-gray-700 font-semibold mb-1">Название роли</label>
          <input type="text" v-model="roleName" required class="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500" placeholder="Введите название роли" />
        </div>
        <div>
          <label class="block text-gray-700 font-semibold mb-1">Доступ к страницам</label>
          <div v-for="permission in permissions" :key="permission.id" class="flex items-center">
            <input type="checkbox" :value="permission.id" v-model="selectedPermissions" class="mr-2" />
            <span>{{ translatePermission(permission.name) }}</span>
          </div>
        </div>
        <button type="submit" class="w-full bg-green-600 hover:bg-green-700 text-white font-semibold p-3 rounded-md transition duration-200">Создать роль</button>
      </form>
    </div>
  </template>

  <script>
  import { createRoleWithPermissions, getPermissions } from "@/services/roleService";

  export default {
    name: "RoleForm",
    data() {
      return {
        roleName: "", // Название новой роли
        selectedPermissions: [], // Список выбранных разрешений
        permissions: [], // Все доступные разрешения
        permissionTranslations: {
          view_dashboard: "Доступ к странице Дашборд",
          manage_users: "Страница Роли",
          view_reports: "Страница Заявки",
          manage_roles: "Страница Оценки",
          view_accounting: "Страница Бухгалтерии",
        },
      };
    },
    async created() {
      try {
        const permissionsResponse = await getPermissions();
        this.permissions = permissionsResponse.data.permissions;
      } catch (error) {
        console.error("Ошибка при загрузке разрешений:", error);
      }
    },
    methods: {
      async createRole() {
        try {
          await createRoleWithPermissions({
            name: this.roleName,
            permissions: this.selectedPermissions,
          });
          alert("Роль успешно создана");
          this.resetForm();
          this.$emit("roleCreated"); // Вызываем событие для обновления списка ролей
        } catch (error) {
          console.error("Ошибка при создании роли:", error);
          alert("Не удалось создать роль");
        }
      },
      resetForm() {
        this.roleName = "";
        this.selectedPermissions = [];
      },
      translatePermission(permissionName) {
        return this.permissionTranslations[permissionName] || permissionName;
      },
    },
  };
  </script>
